import React from "react";
import COBRA_ICON from "./CobraIcon";
import HANGING_ICON from "./HangingIcon";
import DECORATIVE_ICON from "./DecorativeIcon";
import {
  BracketTypeDisplayMap,
  EBracketTypes,
} from "../../../shared/enums/utility.enums";
import { StreetlightIconType, IStreetlightIconProps } from "../Icon.types";

const renderIcon = (
  className: string,
  reported: number,
  type: StreetlightIconType,
  bgFill: string | undefined,
  fill: string | undefined
) => {
  if (type === BracketTypeDisplayMap.COB) {
    type = EBracketTypes.COBRA;
  }

  if (type === BracketTypeDisplayMap.PT) {
    type = EBracketTypes.POST_TOP;
  }

  if (type === BracketTypeDisplayMap.CS) {
    type = EBracketTypes.CENTER_SUSPENSION;
  }

  if (type === EBracketTypes.CENTER_SUSPENSION)
    return (
      <HANGING_ICON
        className={className}
        reported={reported}
        type={type}
        bgFill={bgFill}
        fill={fill}
      />
    );

  if (type === EBracketTypes.POST_TOP)
    return (
      <DECORATIVE_ICON
        className={className}
        reported={reported}
        type={type}
        bgFill={bgFill}
        fill={fill}
      />
    );

  return (
    <COBRA_ICON
      className={className}
      reported={reported}
      type={type}
      bgFill={bgFill}
      fill={fill}
    />
  );
};

const STREETLIGHT_ICON: React.FC<IStreetlightIconProps> = (
  props: IStreetlightIconProps
) => {
  const { type, reported, className, bgFill, fill } = props;
  return renderIcon(
    `${className} streetlight-icon`,
    reported,
    type,
    bgFill,
    fill
  );
};

export default STREETLIGHT_ICON;
